module.exports = __webpack_public_path__ + "img/op22.6799691a.png";